import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { UserIdToUserNamePipe } from '@app/features/users/user-id-to-user-name.pipe';
import { HistoryText as Text, HistoryTextPart } from '../history-entry.model';

/** Rend un texte du fil d'historique en nommant les utilisateurs qu'il désigne. */
@Component({
  selector: 'app-history-text',
  imports: [UserIdToUserNamePipe],
  templateUrl: './history-text.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './history-text.scss',
})
export class HistoryText {
  readonly text = input.required<Text>();

  isText(part: HistoryTextPart): part is string {
    return typeof part === 'string';
  }
}
